import { ProjectColumn } from 'shared/types';
import { ConfirmDialog } from '@/components/dialogs/shared/ConfirmDialog';
import type { DeleteResult } from '@/lib/modals';

export interface DeleteColumnDialogProps {
  column: ProjectColumn;
  projectId: string;
  taskCount: number;
}

export const DeleteColumnDialog = {
  show: async (
    props: DeleteColumnDialogProps
  ): Promise<DeleteResult> => {
    if (props.taskCount > 0) {
      await ConfirmDialog.show({
        title: 'Cannot Delete Column',
        message: `Column "${props.column.name}" contains ${props.taskCount} tasks. Move tasks to another column first before deleting.`,
        confirmText: 'OK',
        cancelText: undefined,
        variant: 'info',
        icon: true,
      });
      return 'canceled';
    }

    const result = await ConfirmDialog.show({
      title: 'Delete Column',
      message: `Are you sure you want to delete column "${props.column.name}"?`,
      confirmText: 'Delete',
      cancelText: 'Cancel',
      variant: 'destructive',
      icon: true,
    });

    if (result === 'confirmed') {
      const { columnsApi } = await import('@/lib/api');
      await columnsApi.delete(props.column.id);
      return 'deleted';
    }

    return 'canceled';
  },
};